export default __webpack_public_path__ + "static/media/Plissee 18 mm seitlich.070658e4.jpg";